import { openMetadataApiClient } from '@/shared/api/core/axios-instance';

export type SampleDataResponse = {
  columns: string[];
  rows: Array<Array<unknown>>;
};

export const fetchTableSampleData = async (entityId: string): Promise<SampleDataResponse | null> => {
  const response = await openMetadataApiClient.get<{ sampleData?: SampleDataResponse }>(
    `/tables/${entityId}/sampleData`
  );

  return response.data.sampleData || null;
};

export const fetchTopicSampleData = async (entityId: string): Promise<SampleDataResponse | null> => {
  const response = await openMetadataApiClient.get<SampleDataResponse | null>(`/topics/${entityId}/sampleData`);

  return response.data || null;
};
